// extracted by mini-css-extract-plugin
module.exports = {"layout":"SEOLandingLayout_layout__4k9ll","layout_opacity":"SEOLandingLayout_layout_opacity__lmaLH","main":"SEOLandingLayout_main__4rSnP"};